import { render, staticRenderFns } from "./LabelTextArea.vue?vue&type=template&id=abfa11be&scoped=true&"
import script from "./LabelTextArea.vue?vue&type=script&lang=js&"
export * from "./LabelTextArea.vue?vue&type=script&lang=js&"
import style0 from "./LabelTextArea.vue?vue&type=style&index=0&id=abfa11be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfa11be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
